module.exports = __webpack_public_path__ + "img/13.dd77da32.png";